<div class="modal-header qa-mc-header">
  <h4 class="modal-title">{{_(KEYS.MEDIA_CENTER.MEDIA_LIB)}}</h4>
  <button type="button" class="close" (click)="activeModal.dismiss()" aria-label="Close">
    <i class="fa fa-close" aria-hidden="true"></i>
  </button>
</div>

<div class="modal-body qa-media-center" *ngIf="!uploadMode">
  <div class="qa-mc-layout" [class.qa-mc-has-preview]="!!selectedFile">
    <section class="qa-mc-library">
      <div class="qa-mc-toolbar">
        <div class="qa-mc-search">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input
            type="search"
            class="form-control"
            placeholder="{{_(KEYS.MEDIA_CENTER.SEARCH_FILES)}}"
            [attr.aria-label]="_(KEYS.MEDIA_CENTER.SEARCH_FILES)"
            [(ngModel)]="nameFilter"
          />
        </div>
        <label class="btn btn-primary qa-mc-upload" *ngIf="!options.disableUpload">
          <i class="fa fa-upload" aria-hidden="true"></i>
          {{_(KEYS.MEDIA_CENTER.UPLOAD)}}
          <input
            type="file"
            (change)="onUpload($event)"
            [attr.accept]="options.accept ? options.accept : null"
            hidden multiple>
        </label>
      </div>

      <div class="qa-mc-list" *ngIf="getFiles().length; else qaMcEmpty">
        <div class="qa-mc-list-head">
          <span></span>
          <span>{{_(KEYS.MEDIA_CENTER.FILE)}}</span>
          <span>{{_(KEYS.MEDIA_CENTER.SIZE)}}</span>
          <span>{{_(KEYS.MEDIA_CENTER.DATE)}}</span>
          <span></span>
        </div>
        <div class="qa-mc-list-body">
          <div
            *ngFor="let file of getFiles()"
            class="qa-mc-row"
            [class.selected]="!!file.options.selected"
            role="button"
            tabindex="0"
            (click)="onSelectFile(file)"
            (keydown.enter)="onSelectFile(file)"
          >
            <span class="qa-mc-type"><i class="fa" [ngClass]="getFileIcon(file)" aria-hidden="true"></i></span>
            <span class="qa-mc-name">{{file.name}}</span>
            <span class="qa-mc-size">{{file.size / 1024 / 1024 | number:'1.0-2'}} MB</span>
            <span class="qa-mc-date">{{file.date | datex:dateFormat}}</span>
            <span class="qa-mc-actions">
              <button
                type="button"
                class="qa-mc-icon-btn"
                [attr.title]="_(KEYS.MEDIA_CENTER.DOWNLOAD)" [attr.aria-label]="_(KEYS.MEDIA_CENTER.DOWNLOAD)"
                (click)="onDownloadFile(file); $event.stopPropagation()"
              >
                <i class="fa fa-download" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="qa-mc-icon-btn qa-mc-icon-btn-danger"
                [attr.title]="_(KEYS.MEDIA_CENTER.DELETE)" [attr.aria-label]="_(KEYS.MEDIA_CENTER.DELETE)"
                (click)="onDeleteFile(file); $event.stopPropagation()"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </div>
      </div>

      <ng-template #qaMcEmpty>
        <div class="qa-mc-empty">
          <span class="qa-mc-empty-icon"><i class="fa" [ngClass]="nameFilter ? 'fa-search' : 'fa-picture-o'" aria-hidden="true"></i></span>
          <ng-container *ngIf="nameFilter; else qaMcNoFiles">
            <strong>{{_(KEYS.MEDIA_CENTER.NO_MATCHING_FILES)}}</strong>
          </ng-container>
          <ng-template #qaMcNoFiles>
            <strong>{{_(KEYS.MEDIA_CENTER.NO_FILES)}}</strong>
            <p *ngIf="!options.disableUpload">{{_(KEYS.MEDIA_CENTER.NO_FILES_HINT)}}</p>
          </ng-template>
        </div>
      </ng-template>
    </section>

    <aside class="qa-mc-preview" *ngIf="selectedFile">
      <div class="qa-mc-stage">
        <video *ngIf="selectedFile.type.match('^video')"
          #video class="qa-video" controls crossorigin="anonymous"
          [attr.poster]="selectedFile.options.previewImage ? selectedFile.options.previewImage : null"
          [src]="baseUri + '/' + selectedFile.name"
        >
          <source [src]="baseUri + '/' + selectedFile.name"/>
        </video>

        <audio *ngIf="selectedFile.type.match('^audio')" controls>
          <source [src]="baseUri + '/' + selectedFile.name"/>
        </audio>

        <ng-container *ngIf="selectedFile.type.match('^image')">
          <img #previewImage
            class="qa-image"
            *ngIf="!imageEditMode && !selectedFile.options.croppedImage"
            [src]="baseUri + '/' + selectedFile.name"
            alt=""
          />
          <img #previewImage
            class="qa-image"
            *ngIf="!imageEditMode && selectedFile.options.croppedImage"
            [src]="selectedFile.options.croppedImage"
            alt=""
          />
          <image-cropper
            #imageCropper
            *ngIf="imageEditMode"
            [autoCrop]="false"
            [aspectRatio]="options.aspectRatio ? options.aspectRatio : 1"
            [maintainAspectRatio]="!!options.maintainAspectRatio"
            [imageBase64]="selectedImage"
            (imageLoaded)="onImageLoaded()"
            (imageCropped)="onImageCropped($event)"
            format="jpeg"
          ></image-cropper>
        </ng-container>

        <div class="qa-mc-no-preview" *ngIf="!selectedFile.type.match('(^audio)|(^video)|(^image)')">
          <i class="fa fa-file-o" aria-hidden="true"></i>
          <span>{{_(KEYS.MEDIA_CENTER.NO_PREVIEW_FOR_THIS_FILE_TYPE)}}</span>
        </div>
      </div>

      <div class="qa-mc-meta">
        <strong class="qa-mc-meta-name">{{selectedFile.name}}</strong>
        <span>{{selectedFile.size / 1024 / 1024 | number:'1.0-2'}} MB · {{selectedFile.date | datex:dateFormat}}</span>
      </div>

      <div class="qa-mc-preview-actions">
        <ng-container *ngIf="selectedFile.type.match('^image')">
          <button type="button" class="btn btn-outline-primary" *ngIf="!imageEditMode" (click)="onEditImage()">
            <i class="fa fa-crop" aria-hidden="true"></i> {{_(KEYS.MEDIA_CENTER.EDIT_IMAGE)}}
          </button>
          <button type="button" class="btn btn-primary" *ngIf="imageEditMode" (click)="onEditImageDone()">
            <i class="fa fa-check" aria-hidden="true"></i> {{_(KEYS.MEDIA_CENTER.APPLY_CROP)}}
          </button>
        </ng-container>

        <ng-container *ngIf="selectedFile.type.match('^video') || selectedFile.type.match('^audio')">
          <div ngbDropdown placement="bottom-left" container="body" class="d-inline-block">
            <button type="button" class="btn btn-outline-primary" ngbDropdownToggle>
              <i class="fa fa-sliders" aria-hidden="true"></i> {{_(KEYS.MEDIA_CENTER.PLAYBACK)}}
            </button>
            <div ngbDropdownMenu class="qa-mc-playback-menu">
              <label class="dropdown-item">
                <input type="checkbox" [(ngModel)]="selectedFile.options.autoPlay">
                {{_(KEYS.MEDIA_CENTER.AUTO_PLAY)}}
              </label>
              <label class="dropdown-item">
                <input type="checkbox" [(ngModel)]="selectedFile.options.hideControls">
                {{_(KEYS.MEDIA_CENTER.DEACTIVATE_CONTROLS)}}
              </label>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="onCreateVideoPreviewImage()"
            *ngIf="selectedFile.type.match('^video')"
          >
            <i class="fa fa-image" aria-hidden="true"></i>
            {{_(KEYS.MEDIA_CENTER.CREATE_PREVIEW)}}
          </button>
        </ng-container>
      </div>
    </aside>
  </div>
</div>

<div class="modal-body qa-media-center qa-mc-uploading" *ngIf="uploadMode">
  <div class="qa-mc-upload-item" *ngFor="let upload of uploads">
    <span class="qa-mc-upload-name"><i class="fa fa-upload" aria-hidden="true"></i> {{upload.fileName}}</span>
    <ngb-progressbar type="primary" height="6px" [value]="upload.progress | async"></ngb-progressbar>
  </div>
</div>

<div class="modal-footer qa-mc-footer">
  <button class="btn btn-outline-primary qa-mc-zip" *ngIf="options.enableZipDownload && getFiles().length" (click)="onZipDownload()">
    <i class="fa fa-file-zip-o" aria-hidden="true"></i>
    {{_(KEYS.MEDIA_CENTER.ZIP_DOWNLOAD)}}
  </button>
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{_(KEYS.MEDIA_CENTER.CANCEL)}}
  </button>
  <button type="button" class="btn btn-primary" (click)="close(true)">
    {{_(KEYS.MEDIA_CENTER.OK)}}
  </button>
</div>
